export * from './src/restaurants-v1-operation-group-operation-groups.universal.js';
